import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdFirstRecommendationRun } from "./constants";
import type {
  GetDecisioningStudioAgentsAppGroupIdDsaIdFirstRecommendationRunProps,
  GetDecisioningStudioAgentsAppGroupIdDsaIdFirstRecommendationRunResult,
} from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdFirstRecommendationRunResult } from "./validators";

/** Fetches a fresh preview without selecting a lifecycle context. */
export const getDecisioningStudioAgentsAppGroupIdDsaIdFirstRecommendationRun = reactQueryFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdFirstRecommendationRun,
  (
    signal: AbortSignal,
    { appGroupId, dsaId }: GetDecisioningStudioAgentsAppGroupIdDsaIdFirstRecommendationRunProps
  ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdFirstRecommendationRunResult> => {
    return fetch(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/first_recommendation_run`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetDecisioningStudioAgentsAppGroupIdDsaIdFirstRecommendationRunResult
);
